import enTranslation from './locales/en/translation';
import enGamesData from './locales/en/gamesData';
import zhTranslation from './locales/zh/translation';
import zhGamesData from './locales/zh/gamesData';

const languages = {
    en: { ...enTranslation, ...enGamesData },
    zh: { ...zhTranslation, ...zhGamesData },
};

let lng = sessionStorage.getItem('language') || 'en';

export const setLanguage = (language) => {
    lng = language;
    sessionStorage.setItem('language', language);
};

export const t = (key) => {
    return languages[lng][key] || key;
};